import {SnackbarContent, CustomContentProps} from "notistack";
import React from "react";
import WarningAmberSharpIcon from '@mui/icons-material/WarningAmberSharp';


const CustomWarning = React.forwardRef<HTMLDivElement, CustomContentProps>((props, ref) => {

    const {
        message
    } = props

    return (
        <SnackbarContent ref={ref}>
            <div className="alert alert--warning" style={{minWidth: "250px"}}>
                <div className="alert__prefix">
                    <WarningAmberSharpIcon />
                </div>
                <div className="alert__header">{message}</div>
            </div>
        </SnackbarContent>
    )
})

export {CustomWarning}